// export const SET_TITLE = "SET_TITLE";
// export const SET_KEY_TAB_BOTTOM = "SET_KEY_TAB_BOTTOM";

export const SET_TITLE = "SET_TITLE";
export const SET_KEY_TAB_BOTTOM = "SET_KEY_TAB_BOTTOM";
export const SET_HIDDEN_TAB_BOTTOM = "SET_HIDDEN_TAB_BOTTOM";



export const SET_USER = "SET_USER";